import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ArticleIcon from '@mui/icons-material/Article';
import TableChartIcon from '@mui/icons-material/TableChart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ImageIcon from '@mui/icons-material/Image';
import CodeIcon from '@mui/icons-material/Code';
import ArchiveIcon from '@mui/icons-material/Archive';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export function getFileTypeIcon(filename: string): React.ReactNode {
  const ext = filename.split('.').pop()?.toLowerCase() || '';
  switch (ext) {
    case 'pdf':
      return <PictureAsPdfIcon fontSize="small" sx={{ color: '#d32f2f' }} />;
    case 'doc':
    case 'docx':
      return <ArticleIcon fontSize="small" sx={{ color: '#2196f3' }} />;
    case 'xls':
    case 'xlsx':
    case 'csv':
      return <TableChartIcon fontSize="small" sx={{ color: '#4caf50' }} />;
    case 'ppt':
    case 'pptx':
      return <AssessmentIcon fontSize="small" sx={{ color: '#ff9800' }} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'svg':
      return <ImageIcon fontSize="small" sx={{ color: '#9c27b0' }} />;
    case 'zip':
    case 'rar':
    case '7z':
    case 'tar':
    case 'gz':
      return <ArchiveIcon fontSize="small" sx={{ color: '#795548' }} />;
    case 'txt':
    case 'md':
    case 'json':
    case 'xml':
    case 'html':
    case 'css':
    case 'js':
    case 'ts':
      return <CodeIcon fontSize="small" sx={{ color: '#607d8b' }} />;
    default:
      return <InsertDriveFileIcon fontSize="small" sx={{ color: '#9e9e9e' }} />;
  }
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
}

export function formatDocumentType(type: string): string {
  return type
    .split('_')
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
}
